import { api } from "../../http";

async function GetAllRrimInAprovados(page = 0, offset = 10, statusId = 1) {
    try {
        const list_rrim = (await api.get(`/rrim/list/aprovadas?page=${page}&offset=${offset}&statusId=${statusId}`)).data


        return list_rrim
    } catch (error) {
        console.log(error)
    }
}

export { GetAllRrimInAprovados }
